import type { TMessages } from '@/types/TMessages'

export const messages = {
  allFilters: 'Все фильтры',
  hide: 'Скрыть',
} satisfies TMessages
